import React, { useEffect, useRef, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { storage } from '../../firebase'
import { getDownloadURL, uploadBytes, ref as sRef } from 'firebase/storage'
import { getLabel, updateLabel } from '../../api/labels'


const AdminEditLabel = () => {





    //////////////////////////////////////////////
    ////////////////// BACKEND ///////////////////
    //////////////////////////////////////////////

    const { index, uid } = useParams()

    const [labels, setLabels] = useState([])

    const [name, setName] = useState('')
    const [country, setCountry] = useState('')
    const [editUserKey, setEditUserKey] = useState('')
    const [editLabelIndex, setEditLabelIndex] = useState('')

    const successBtn = useRef()

    //////////// GET USER'S RELEASES ////////////
    const [isLoading, setIsLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [error, setError] = useState(null);

    // Modified useEffect for initial data loading
    useEffect(() => {
        const loadData = async () => {
            try {
                setIsLoading(true);
                const { label } = await getLabel(uid, index);
                initialValues(label);
                setError(null);
            } catch (err) {
                setError('Failed to load label data');
                console.error('Loading error:', err);
            } finally {
                setIsLoading(false);
            }
        };

        loadData();
    }, [uid, index]);
    const initialValues = (item) => {
        setName(item.name)
        setCountry(item.country)
        setImgSrc(item.logo)
        item.logo && setImgPreview(true)
        item.logo && setUploadLabel('Replace file')
    }


    const fileInputRef = useRef(null);
    const [imgPreview, setImgPreview] = useState(false)
    const [imgSrc, setImgSrc] = useState('')
    const [uploadLabel, setUploadLabel] = useState('Choose file')

    const uploadArtwork = async (event) => {
        setUploadLabel('Please Wait...')
        const file = event.target.files[0];
        const storageRef = sRef(storage, `releases/${file.name}`);

        try {
            // Upload file to Firebase Storage
            await uploadBytes(storageRef, file);

            // Get download URL
            const downloadURL = await getDownloadURL(storageRef);
            setImgSrc(downloadURL)
            setImgPreview(true)
            setUploadLabel('Replace file')
        } catch (error) {
            console.error("Error uploading file:", error);
        }
    }

    const removeImg = () => {
        fileInputRef.current.value = '';
        setImgSrc('')
        setImgPreview(false)
        setUploadLabel('Choose file')
    }


    const editLabel = async () => {
        try {
            setSubmitLoading(true);
            setError(null);
            
            const labelData = {
                name,
                country,
                logo: imgSrc || ''
            };
    
            await updateLabel(uid, index, labelData);
            successBtn.current.click();
        } catch (err) {
            setError(err.message || 'Failed to update label');
            console.error('Submission error:', err);
        } finally {
            setSubmitLoading(false);
        }
    };


    return (
        <div className='dash-section'>
            <h1 className='dash-title'>Edit Label</h1>
            <div className="row">
                <div className="col-12 mt-4">
                    <div className="dash-card">
                        <div className="row">
                            <div className="col-12">
                                <h4 className='dash-card-title'>
                                    <Link to={'/admin/labels'} className='title-back-link'>
                                        <i className="fi fi-rr-arrow-small-left"></i>
                                    </Link>
                                    Edit Label
                                </h4>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Logo</label>
                                    <div className="img-file-upload">
                                        {
                                            imgPreview && (
                                                <div className='img-preview'>
                                                    <img src={imgSrc} alt="" />
                                                    <i className="fi fi-rr-trash remove-artwork" onClick={removeImg}></i>
                                                </div>
                                            )
                                        }
                                        <div className="dash-form-file">
                                            <i className="fi fi-rr-cloud-upload"></i>
                                            {uploadLabel}
                                            <input type="file" ref={fileInputRef} onChange={uploadArtwork} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Name</label>
                                    <input value={name} onChange={(e) => setName(e.target.value)} type="text" placeholder='Name' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-md-6 mt-3">
                                <div className="dash-form-group">
                                    <label>Country</label>
                                    <input value={country} onChange={(e) => setCountry(e.target.value)} type="text" placeholder='Country' className='dash-form-input' />
                                </div>
                            </div>
                            <div className="col-12 mt-3">
                                <div className="dash-form-btns">
                                    <button
                                        className='dash-form-btn'
                                        onClick={editLabel}
                                    >Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <button ref={successBtn} data-bs-target="#successModal" data-bs-toggle="modal" hidden></button>
            <div className="modal fade" id="successModal" tabindex="-1" data-bs-backdrop="static" aria-labelledby="successModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body success-modal">
                            <a className='success-close-btn' href="/admin/labels">
                                <i className="fi fi-rr-cross"></i>
                            </a>
                            <i className="fi fi-rr-check-circle text-success success-icon"></i>
                            <h5>Label Updated Successfully!</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminEditLabel